import { getAuthHeaders } from '../../utils/token';
import { api } from '../Users/user';

const BASE_URL = api + '/api/slots';

// --- Tipos de Referencias Pobladas (Reutilizando Branch/Equipment/Service types) ---

export interface OrganizationReference {
  _id: string;
  name: string;
  short_name: string;
}

export interface BranchReference {
  _id: string;
  name: string;
  short_name: string;
}

export interface EquipmentReference {
  _id: string;
  name: string;
  model: string;
}

export interface ServiceReference {
  _id: string;
  name: string;
}

// --- Interfaz para el Slot devuelto por la API ---
export interface SlotAPI {
  _id: string;
  domain: {
    organization: OrganizationReference;
    branch: BranchReference;
  };
  fk_equipment: EquipmentReference;
  fk_service: ServiceReference;
  start: string; // ISO Date string
  end: string;   // ISO Date string
  urgency: boolean;
  is_available: boolean;
  createdAt: string;
  updatedAt: string;
}

// --- Interfaz para los datos necesarios para crear/actualizar un Slot ---
export interface SlotData {
  organizationId: string;
  branchId: string;
  fk_equipment: string;
  fk_service: string;
  start: string; // Formato YYYY-MM-DDTHH:mm
  end: string;   // Formato YYYY-MM-DDTHH:mm
  urgency: boolean;
  is_available?: boolean;
}

// --- Función de Utilidad para Fetch con Manejo de Errores (Reutilizada) ---
async function apiFetch<T>(url: string, options: RequestInit): Promise<T> {
  const defaultHeaders = getAuthHeaders();
  options.headers = {
    ...defaultHeaders,
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, options);
  const data = await response
    .json()
    .catch(() => ({ message: response.statusText || 'Error desconocido' }));

  if (!response.ok) {
    throw new Error(data.message || `La petición falló con status ${response.status}`);
  }

  return data as T;
}

/**
 * Obtiene slots filtrados por query params (fecha, sucursal, equipo).
 */
export function fetchSlots(queryParams: Record<string, string> = {}): Promise<SlotAPI[]> {
  const queryString = new URLSearchParams(queryParams).toString();
  return apiFetch<SlotAPI[]>(`${BASE_URL}?${queryString}`, {
    method: 'GET',
  });
}

/**
 * Crea un nuevo Slot.
 */
export function createSlot(slotData: SlotData): Promise<SlotAPI> {
  return apiFetch<SlotAPI>(BASE_URL, {
    method: 'POST',
    body: JSON.stringify(slotData),
  });
}

/**
 * Actualiza un Slot existente.
 */
export function updateSlot(
  id: string,
  slotData: Partial<SlotData>
): Promise<SlotAPI> {
  return apiFetch<SlotAPI>(`${BASE_URL}/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(slotData),
  });
}

/**
 * Elimina un Slot por su ID.
 */
export function deleteSlot(id: string): Promise<void> {
  return apiFetch<void>(`${BASE_URL}/${id}`, {
    method: 'DELETE',
  });
}
